import axios from "./axios";

function readBlobAsText(blob) {
  if (typeof blob?.text === "function") return blob.text();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    reader.readAsText(blob);
  });
}

async function requirePdfBlob(data) {
  if (!(data instanceof Blob)) {
    const err = new Error("Invalid pdf");
    err.code = "SIGNING_PDF_INVALID";
    throw err;
  }
  const header = await readBlobAsText(data.slice(0, 4));
  if (header !== "%PDF") {
    let message = "Invalid pdf";
    try {
      const json = JSON.parse(await readBlobAsText(data));
      if (Array.isArray(json.errors) && json.errors.length) {
        message = json.errors.join(", ");
      }
    } catch (_) {
      /* HTML or empty error body */
    }
    const err = new Error(message);
    err.code = "SIGNING_PDF_INVALID";
    throw err;
  }
  return data;
}

export async function fetchSigningRequests(params = {}) {
  return axios.get("/signing/requests", { params }).then((response) => response.data);
}

export async function createSigningRequest(payload) {
  return axios
    .post("/signing/requests", { signing_request: payload })
    .then((response) => response.data);
}

export async function createServiceAgreementSigningRequest(agreementId, payload) {
  return axios
    .post(`/service/agreements/${agreementId}/signing_requests`, {
      signing_request: payload,
    })
    .then((response) => response.data);
}

export async function createEmployeeSigningRequest(userId, employeeId, payload) {
  return axios
    .post(`/users/${userId}/employees/${employeeId}/signing_requests`, {
      signing_request: payload,
    })
    .then((response) => response.data);
}

export async function pollSigningRequest(id) {
  return axios.post(`/signing/requests/${id}/poll`).then((response) => response.data);
}

export async function downloadSignedDocument(id) {
  try {
    const response = await axios.get(`/signing/requests/${id}/signed_document`, {
      responseType: "blob",
      headers: { Accept: "application/pdf" },
    });
    const blob = await requirePdfBlob(response.data);
    return { ...response, data: blob };
  } catch (error) {
    if (error?.code === "SIGNING_PDF_INVALID") throw error;
    const data = error?.response?.data;
    if (data instanceof Blob) {
      await requirePdfBlob(data);
    }
    throw error;
  }
}
